import TMBTEImage from '../../assets/albums/covers/tmbte.jpg';
import VinylAlbum from './VinylAlbum';

function TakeMeBackToEden({ albumRef, delay, onClick, isPlaying }) {
  return (
    <VinylAlbum
      image={TMBTEImage}
      alt="Take Me Back To Eden"
      isPlaying={isPlaying}
      onClick={onClick}
      albumRef={albumRef}
      delay={delay}
    />
  );
}

export default TakeMeBackToEden;